import EventSummaryItem from "./eventSummaryItem";

export default class EventCategory {
  id: string;
  name: string;
  isActive: boolean;
  events?: EventSummaryItem[];

  constructor(
    id: string,
    name: string,
    isActive: boolean,
    events: EventSummaryItem[] = []
  ) {
    this.id = id;
    this.name = name;
    this.isActive = isActive;
    this.events = events;
  }
}
